import React from "react";

const CloseIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      className={cls}
    >
      <path
        d="M9.06225 8.49975L12.78 4.78198C13.0734 4.48862 13.0734 4.0131 12.78 3.71974C12.4867 3.42643 12.0111 3.42643 11.7178 3.71974L8 7.43756L4.28223 3.71978C3.98887 3.42647 3.51334 3.42647 3.21998 3.71978C2.92667 4.0131 2.92667 4.48867 3.21998 4.78202L6.93776 8.4998L3.21998 12.2176C2.92667 12.5108 2.92667 12.9865 3.21998 13.2798C3.51334 13.5731 3.98887 13.5731 4.28223 13.2798L8 9.562L11.7178 13.2798C12.0111 13.5731 12.4867 13.5731 12.78 13.2798C13.0734 12.9865 13.0734 12.5109 12.78 12.2175L9.06225 8.49975Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CloseIcon;
